<template>
  <div
    class="bg-white md:h-screen flex flex-col justify-center items-center overflow-y-auto"
  >
    <form
      class="relative rounded-lg flex flex-col gap-y-2 md:gap-y-3 w-full md:w-[75%] max-w-[500px]"
      @submit.prevent="recaptcha"
    >
      <img
        @click="toHome"
        src="../assets/Logo.svg"
        alt="Logo"
        class="h-8 md:h-10"
      />

      <h1 class="text-xl md:text-3xl font-semibold text-center roboto-medium">
        Organization Sign up
      </h1>
      <h2 class="text-sm md:text-xl text-center roboto-regular">
        Welcome to LIVEYfy!
      </h2>
      <TabsList />
      <div class="flex items-center p-1 border rounded-lg gap-x-2 roboto-light">
        <img src="../assets/User.svg" alt="UserName" class="h-5 w-5" />
        <input
          type="text"
          class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
          required
          v-model="fullname"
          onkeypress="return (event.charCode == 8 || event.charCode == 32 || (event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122))"
          placeholder="Full Name *"
        />
      </div>

      <div class="flex items-center p-1 border rounded-lg gap-x-2 relative">
        <div
          ref="dropdownContent"
          @click="is_country_code = !is_country_code"
          class="h-5 w-16 text-sm gap-2 bg-white cursor-pointer flex items-center justify-center"
        >
          <img
            v-if="country_code == ''"
            src="@/assets/globe-2-svgrepo-com.svg"
            class="h-4 w-4 object-contain"
            alt="india"
          />
          <img
            v-else
            :src="require(`@/assets/flags/${this.country_flag}.svg`)"
            class="h-4 w-4 object-contain"
            alt="country-code"
          />
          <img
            src="@/assets/down-arrow-5-svgrepo-com.svg"
            alt="down-arrow"
            class="h-6 w-6"
            :class="[is_country_code ? 'rotate-180' : '']"
          />
        </div>
        <input
          type="text"
          class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
          required
          onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))"
          v-model="mobile"
          placeholder="Mobile Number *"
        />
        <div
          v-if="is_country_code"
          class="absolute top-10 -left-1 bg-white z-50"
        >
          <div class="" ref="country_ref">
            <div
              class="max-h-[330px] overflow-y-auto shadow-xl rounded-sm p-2 border"
            >
              <div class="custom-select-trigger text-gray-300">
                Select an option
              </div>
              <div class="custom-options">
                <span
                  v-for="cc in c_code"
                  :key="cc"
                  class="flex gap-2 items-center justify-start text-xs hover:bg-gray-100 py-1.5 px-2"
                  @click="
                    (country_code = cc.dial_code),
                      (is_country_code = false),
                      (country_flag = cc.code)
                  "
                  ><img
                    :src="require(`@/assets/flags/${cc.code}.svg`)"
                    class="h-4 w-4 object-contain"
                    alt="Option 1"
                  />
                  {{ cc.name }}
                  <span class="text-gray-500">{{ cc.dial_code }}</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex gap-2">
        <div class="flex items-center p-1 border rounded-lg gap-x-2 w-2/3">
          <img src="../assets/mail.svg" alt="UserName" class="h-5 w-5" />
          <input
            type="email"
            class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
            required
            v-model="email"
            placeholder="Enter your Email *"
          />
        </div>
        <div class="w-1/3">
          <!-- <input type="text" name="" id="" class="flex items-center p-1 border rounded-lg gap-x-2 w-full h-full bg-white px-2 text-gray-500 text-sm roboto-light text-center"> -->
          <select
            name=""
            id=""
            v-model="license_limit"
            class="flex items-center p-1 border rounded-lg gap-x-2 w-full h-full bg-white px-2 text-gray-500 text-sm roboto-light text-center"
          >
            <option value="" disabled selected>Select License *</option>
            <option
              :value="i"
              v-for="i in [5, 10, 20, 25, 30, 40, 50, 100]"
              :key="i"
            >
              {{ i }} Licenses
            </option>
          </select>
        </div>
      </div>
      <div class="flex gap-2">
        <div
          class="flex items-center p-1 border rounded-lg gap-x-2 roboto-light w-full"
        >
          <img src="../assets/User.svg" alt="UserName" class="h-5 w-5" />
          <input
            type="text"
            class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
            required
            v-model="org_name"
            placeholder="Organization Name *"
          />
        </div>
        <div
          class="flex items-center p-1 border rounded-lg gap-x-2 roboto-light w-1/2 hidden"
        >
          <img src="../assets/User.svg" alt="UserName" class="h-5 w-5" />
          <input
            type="text"
            class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
            v-model="company_LEI"
            placeholder="LEI"
          />
        </div>
      </div>
      <div class="flex gap-2">
        <div class="flex items-center p-1 border rounded-lg gap-x-2 w-1/2">
          <img src="../assets/lock.svg" alt="UserName" class="h-5 w-5" />
          <input
            type="password"
            class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
            required
            v-model="password"
            placeholder="Enter your Password *"
            minlength="8"
          />
        </div>

        <div
          class="relative flex items-center p-1 border rounded-lg gap-x-2 w-1/2"
        >
          <img src="../assets/lock.svg" alt="UserName" class="h-5 w-5" />
          <input
            type="password"
            class="text-sm placeholder-gray-500 rounded-md w-full py-2 focus:outline-none roboto-light"
            required
            v-model="confirmPassword"
            placeholder="Renter your Password *"
            minlength="8"
          />
        </div>
      </div>
      <p
        v-if="this.message.text != ''"
        class="text-start capitalize"
        :class="[
          this.message.status == 200 ? ' text-green-700' : ' text-red-700',
        ]"
      >
        {{ this.message.text }}
      </p>
      <button
        v-if="!loading"
        type="submit"
        class="w-full border h-[49px] rounded-lg font-bold bg-[#2A84EF] text-white roboto-light"
      >
        Sign up
      </button>
      <button
        v-else
        class="w-full border h-[49px] rounded-lg font-bold bg-[#2A84EF] text-white roboto-light"
      >
        Loading...
      </button>
      <div class="flex flex-col gap-y-4 roboto-light">
        <div class="flex items-center p-2">
          <span class="flex-grow border-b border-gray-300"></span>
          <p class="text-sm text-gray-500 mx-3">Already have an account?</p>
          <span class="flex-grow border-b border-gray-300"></span>
        </div>

        <router-link to="/">
          <button
            class="bg-black text-white rounded-md py-1 text-center roboto-light h-[49px] w-full"
          >
            Sign in here
          </button>
        </router-link>
      </div>
    </form>

    <!-- <div
      v-if="message.text != ''"
      class="fixed top-2 right-2 w-[340px] p-2 bg-gray-100 min-h-[60px] rounded-md flex items-center justify-center text-sm capitalize"
      :class="
        this.message.status != 200
          ? 'border border-red-400 bg-red-300'
          : 'border border-green-400 bg-green-300'
      "
    >
      {{ message.text }}
    </div> -->
    <Footer />
  </div>
</template>

<script>
import Footer from "../components/FooterVIew.vue";
import axios from "axios";
import CC from "@/services/coutryCode.js";
import TabsList from "@/components/SignUpTab.vue";
import { phone } from "phone";

export default {
  name: "LoginPage",
  data() {
    return {
      fullname: "",
      email: "",
      password: "",
      mobile: "",
      confirmPassword: "",
      message: {
        text: "",
        status: "",
      },
      loading: false,
      c_code: [],
      country_code: "",
      is_country_code: false,
      country_flag: "",
      company_LEI: "",
      org_name: "",
      license_limit: "",
    };
  },
  components: {
    TabsList,
    Footer,
  },
  created() {
    // console.log(CC.countryCode());
    this.c_code = CC.countryCode();
  },
  mounted() {
    document.addEventListener("click", this.handleClickOutside);
  },
  watch: {},
  beforeUnmount() {
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    async recaptcha() {
      this.loading = true;
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("login");
      console.log(token);
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API}/api/verify-recaptcha/`,
          { token }
        );
        if (response.data.success) {
          this.signUp();
        } else {
          this.message.text = "reCAPTCHA verification failed.";
          this.message.status = 400;
          setTimeout(() => {
            this.message.text = "";
            this.loading = false;
          }, 3000);
          console.log("reCAPTCHA verification failed.");
        }
      } catch (error) {
        this.message.text = "An error occurred while verifying reCAPTCHA.";
        this.message.status = 400;
        setTimeout(() => {
          this.message.text = "";
          this.loading = false;
        }, 3000);
        console.error("Error verifying reCAPTCHA:", error);
      }
    },
    toHome() {
      this.$router.push({ path: "/" });
    },
    handleClickOutside(event) {
      if (
        this.is_country_code &&
        !this.$refs.country_ref.contains(event.target) &&
        !this.$refs.dropdownContent.contains(event.target)
      ) {
        this.is_country_code = false;
      }
    },
    signUp() {
      this.loading = true;
      let data_json = {
        user: {
          email: this.email,
          phone: this.mobile,
          country_code: this.country_code,
          first_name: this.fullname,
          site: "",
          password: this.password,
        },
        organizational: {
          organizational_name: this.org_name,
          total_limit: this.license_limit,
          current_limit: 0,
          used_limit: 0,
          CEI: this.company_LEI,
        },
      };
      if (this.country_code) {
        let phone_number = this.country_code + " " + this.mobile;
        let number_is_valid = phone(phone_number);
        if (number_is_valid.isValid) {
          if (this.password == this.confirmPassword) {
            axios
              .post(
                `${process.env.VUE_APP_API}/api/create-org-user/`,
                data_json
              )
              .then((response) => {
                console.log(response);

                this.message.text = "Welcome to LIVEYfy!";
                this.message.status = 200;
                this.loading = true;
                setTimeout(() => {
                  this.$router.push({ path: "/" });
                  this.message.text = "";
                  this.loading = false;
                  this.message.status = "";
                }, 5000);
              })
              .catch((error) => {
                console.error("Error:", error);
                this.message.text = error.response.data.user.email[0];
                this.message.status = 400;
                this.loading = true;
                setTimeout(() => {
                  this.message.text = "";
                  this.loading = false;
                  this.message.status = "";
                }, 4000);
              });
          } else {
            this.message.text = "Password dosen't match";
            this.message.status = 400;
            setTimeout(() => {
              this.message.text = "";
              this.loading = false;
            }, 3000);
          }
        } else {
          this.message.text = "Invalid phone number";
          this.message.status = 400;
          setTimeout(() => {
            this.message.text = "";
            this.loading = false;
          }, 3000);
        }
      } else {
        this.message.text = "Please select country code";
        this.message.status = 400;
        setTimeout(() => {
          this.message.text = "";
          this.loading = false;
        }, 3000);
      }
    },
  },
};
</script>

<style scoped></style>
